import React from 'react'

const CustomSelect = ({
	name,
	value,
	onChange,
	options,
	placeholder,
	label,
	required,
	hasError,
	disabled,
	styles, // New prop for custom styles
	className, // New prop for additional classes
}) => {
	// Merge default styles with custom styles
	const mergedStyles = {
		select: {
			cursor: 'pointer',
			border: `1px solid ${hasError ? 'red' : '#d2d6da'}`,
			borderRadius: '10px',
			...styles?.select,
		},
		label: {
			color: 'black',
			...styles?.label,
		},
		option: {
			...styles?.option,
		},
	}

	return (
		<div className={`mb-2 ${className || ''}`}>
			{label && (
				<label className='form-label fw-bold' style={mergedStyles.label}>
					{label} {required && <span className='text-danger'>*</span>}
				</label>
			)}
			<div className='input-group input-group-outline'>
				<select
					name={name}
					className={`form-control ${hasError ? 'is-invalid' : ''}`}
					value={value}
					onChange={onChange}
					style={mergedStyles.select}
					disabled={disabled}
				>
					{placeholder && <option value=''>{placeholder}</option>}
					{options?.map((option) => (
						<option key={option.value} value={option.value} style={mergedStyles.option}>
							{option.label}
						</option>
					))}
				</select>
			</div>
		</div>
	)
}

export default CustomSelect
